import { render } from "./BoxPage.vue?vue&type=template&id=f72d45ce&scoped=true"
import script from "./BoxPage.vue?vue&type=script&lang=js"
export * from "./BoxPage.vue?vue&type=script&lang=js"

import "./BoxPage.vue?vue&type=style&index=0&id=f72d45ce&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f72d45ce"],['__file',"src/views/ProductManage/ModelManagement/components/BoxPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f72d45ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f72d45ce', __exports__)) {
    api.reload('f72d45ce', __exports__)
  }
  
  module.hot.accept("./BoxPage.vue?vue&type=template&id=f72d45ce&scoped=true", () => {
    api.rerender('f72d45ce', render)
  })

}


export default __exports__